import React from 'react';
import { Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { TextField, Checkbox, RadioGroup } from "../common/FormComponents";
import { FormControlLabel, Radio, MenuItem } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBirthdayCake, faUserShield, faBook, faMapMarkerAlt, faClipboardList, faClock, faParagraph, faDna, faPlus, faMinus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import {toArray} from "../common/util";

const validate = values => {
    const errors = {};
    if (!values.name) {
        errors.name = '* Required';
    } else if (values.name.length < 2) {
        errors.name = '* Must be more than 2 characters';
    }
    if (!values.birthdate) {
        errors.birthdate = '* Required (YYYY/MM/DD)';
    } else if (values.birthdate === "Unknown") {
        errors.birthdate = '* Required';
    }
    if (!values.gender) {
        errors.gender = '* Required';
    }
    if (!values.location) {
        errors.location = '* Required';
    } else if (values.location.length < 2) {
        errors.location = '* Must be more than 2 characters';
    }
    if (!values.microphone) {
        errors.microphone = '* Required';
    }
    if (!values.pc) {
        errors.pc = '* Required';
    }
    if (!values.technicalSkills) {
        errors.technicalSkills = '* Required';
    }
    if (!values.characterName) {
        errors.characterName = '* Required';
    } else if (values.characterName.length < 2) {
        errors.characterName = '* Must be more than 2 characters';
    }
    if (!values.characterClass) {
        errors.characterClass = '* Required';
    } else if (values.characterClass.length < 2) {
        errors.characterClass = '* Must be more than 2 characters';
    }
    if (!values.characterLevel) {
        errors.characterLevel = '* Required';
    }


    //game array
    const gameHistoryArrayErrors = [];
    if (!values.gameHistory || !values.gameHistory.length) {
        errors.gameHistory = {_error: 'At least one member must be entered'}
    } else {
        values.gameHistory.forEach((game, gameIndex) => {
            const gameErrors = {};
            if (!game || !game.title) {
                gameErrors.title = '* Required';
                gameHistoryArrayErrors[gameIndex] = gameErrors
            }
            if (!game || !game.duration) {
                gameErrors.duration = 'Required';
                gameHistoryArrayErrors[gameIndex] = gameErrors
            }
            if (!game || !game.average) {
                gameErrors.average = 'Required';
                gameHistoryArrayErrors[gameIndex] = gameErrors
            }
            if (!game || !game.role) {
                gameErrors.role = '* Required';
                gameHistoryArrayErrors[gameIndex] = gameErrors
            }

        })
    }
    if (gameHistoryArrayErrors.length) {
        errors.gameHistory = gameHistoryArrayErrors
    }


    if (!values.game_0) {
        errors.game_0 = '* Required';
    }
    if (!values.gameDuration_0) {
        errors.gameDuration_0 = '* Required';
    }
    if (!values.gameAverage_0) {
        errors.gameAverage_0 = '* Required';
    }
    if (!values.gameRole_0) {
        errors.gameRole_0 = '* Required';
    }


    if (!values.playtime) {
        errors.playtime = '* Required (hours per week)';
    }

    if (!values.playerTypeOne) {
        errors.playerTypeOne = '* Required';
    }
    if (!values.playerTypeTwo) {
        errors.playerTypeTwo = '* Required';
    } else if (values.playerTypeTwo === values.playerTypeOne) {
        errors.playerTypeTwo = '* Duplicate of first choice';
    }
    if (!values.playerTypeThree) {
        errors.playerTypeThree = '* Required';
    } else if (values.playerTypeThree === values.playerTypeOne) {
        errors.playerTypeThree = '* Duplicate of first choice';
    } else if (values.playerTypeThree === values.playerTypeTwo) {
        errors.playerTypeThree = '* Duplicate of second choice';
    }
    if (!values.whyJoin) {
        errors.whyJoin = '* Required';
    }
    return errors;
};

const normalizeHours = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums > 168) {
        return 168
    }
    if (onlyNums.length <= 3) {
        return Number(onlyNums)
    }
    return Number(onlyNums.slice(0, 2))
};

const normalizeYears = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d.]/g, '')
    if (onlyNums > 100) {
        return 100
    }
    if (onlyNums.length <= 4) {
         return onlyNums
    }

    return onlyNums.slice(0, 3)
};

const normalizeLevel = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums > 9999) {
        return 9999
    }
    if (onlyNums.length <= 4) {
        return Number(onlyNums)
    }

    return Number(onlyNums.slice(0, 3))
};

const normalizeBday = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (!previousValue || value.length > previousValue.length) {

        if (onlyNums.slice(0, 4) > new Date().getUTCFullYear()) {
            return 2018 + '/' + onlyNums.slice(4)
        }

        if (onlyNums.slice(4, 6) > 12) {
            return onlyNums.slice(0, 4) + '/' + 12 + '/'
        }

        if (onlyNums.slice(6, 8) > new Date(onlyNums.slice(0, 4), onlyNums.slice(4, 6), 0).getUTCDate()) {
            return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4, 6) + '/' + new Date(onlyNums.slice(0, 4), onlyNums.slice(4, 6), 0).getUTCDate()
        }

        // typing forward
        if (onlyNums.length === 4) {
            return onlyNums + '/'
        }
        if (onlyNums.length === 6) {
            return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4) + '/'
        }
    }
    if (onlyNums.length <= 4) {
        return onlyNums
    }
    if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4)
    }
    return onlyNums.slice(0, 4) + '/' + onlyNums.slice(4, 6) + '/' + onlyNums.slice(6, 8)
};

const normalizeGame = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyLetters = value.replace(/[^a-zA-Z\s]+$/, '');
    return onlyLetters
};

const renderGames = ({fields, onKeyPress, meta: {error, submitFailed}}) => (
    <div>
        {fields.map((game, index) => (
            <Row key={index}>
                <Col>
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faBook} fixedWidth />
                    <span style={{display:"inline-block", paddingLeft:"5px"}}>
                        <Field component={TextField}
                            name={`${game}.title`}
                            type="text"
                            label="Game"
                            fullWidth
                            helperText={<span></span>}
                            normalize={normalizeGame}
                            onKeyPress={onKeyPress}
                            />
                    </span>
                    <span> for </span>
                    <span style={{display:"inline-block", paddingLeft:"5px"}}>
                        <Field component={TextField}
                            name={`${game}.duration`}
                            type="text"
                            label="Years"
                            helperText={<span></span>}
                            style={{width: "40px"}}
                            normalize={normalizeYears}
                            onKeyPress={onKeyPress}
                            />
                    </span>
                    <span> years, averaging </span>

                    <span style={{display:"inline-block", paddingLeft:"5px"}}>
                    <Field component={TextField}
                        name={`${game}.average`}
                        type="text"
                        label="Hours"
                        helperText={<span></span>}
                        style={{width: "40px"}}
                        normalize={normalizeHours}
                        onKeyPress={onKeyPress}
                        />
                    </span>

                    <span>hours per week as a</span>
                    <span style={{display:"inline-block", paddingLeft:"5px"}}>
                    <Field component={TextField}
                        name={`${game}.role`}
                        select
                        fullWidth
                    >
                        <MenuItem value="Member">Member</MenuItem>
                        <MenuItem value="Class Lead">Class Lead</MenuItem>
                        <MenuItem value="Raid Leader">Raid Leader</MenuItem>
                        <MenuItem value="Officer">Officer</MenuItem>
                        <MenuItem value="Guild Leader">Guild Leader</MenuItem>
                    </Field>
                    </span>

                    <FontAwesomeIcon className="fake-link text-primary" icon={faMinus} fixedWidth onClick={() => fields.remove(index)} />
                </Col>
            </Row>
        ))}
        <div className="adt-flex-container">
            <div className="adt-flex-item">
            <Button className="pull-right" type="button" onClick={() => fields.push({})}><FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth /> Add Another</Button>
            </div>
        </div>
    </div>
);

const renderError = ({input, meta, ...props}) => (
    <div>
    {!meta.touched ? ('') : (
        <div className="text-danger">{meta.error}</div>
    )}
    </div>
);

const StepOneForm = props => {

    // Stop form from submitting on Enter keypress
    const onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    return (
        <Form onSubmit={props.handleSubmit}>
            <div className="panel-adt">
                <h3>Personal Information</h3>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faUser} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                    <Field component={TextField}
                        name="name"
                        type="text"
                        label="Full Name"
                        fullWidth
                        helperText={<span></span>}
                        onKeyPress={onKeyPress}
                        />
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faBirthdayCake} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="birthdate"
                            label="Birthday"
                            helperText="(YYYY/MM/DD)"
                            onKeyPress={onKeyPress}
                            normalize={normalizeBday}
                        />
                    </div>
                    <div className="adt-flex-item">
                        <Field name="gender" component={RadioGroup}>
                            <FormControlLabel value="Male" control={<Radio onChange={this.handleChange} onKeyPress={onKeyPress} />} label="Male" />
                            <FormControlLabel value="Female" control={<Radio onChange={this.handleChange} onKeyPress={onKeyPress} />} label="Female" />
                            <Field name='gender' component={renderError} />
                        </Field>
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faMapMarkerAlt} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="location"
                            type="text"
                            label="Location"
                            fullWidth
                            helperText={<span></span>}
                            onKeyPress={onKeyPress}
                            />
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faDiscord} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="discord"
                            type="text"
                            label="Discord"
                            fullWidth
                            helperText="User#0000"
                            onKeyPress={onKeyPress}
                            />
                    </div>
                </div>
            </div>
            <div className="panel-adt">
                <h3>Technical Information</h3>
                <div className="adt-flex-container">
                    <p style={{margin:0}}>Do you have any technically oriented skills such as programming, video/sound editing, or spreadsheet skills, etc?</p>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faClipboardList} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="technicalSkills"
                            type="text"
                            label="Relevant technical skills"
                            multiline
                            fullWidth
                            onChange={this.handleChange}
                            helperText="Press Enter for more lines."
                        />
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-item-small">
                        <FormControlLabel control={<Field name="microphone" component={Checkbox} onChange={this.handleChange} onKeyPress={onKeyPress} /> } label="Functional Microphone" />
                        <FormControlLabel control={<Field name="pc" component={Checkbox} onChange={this.handleChange} onKeyPress={onKeyPress} /> } label="PC meets minimum requirements" />
                        <div>
                        <span className="pull-left"><Field name='microphone' component={renderError} /></span>
                        <span className="pull-right"><Field name='pc' component={renderError} /></span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="panel-adt">
                <h3>Character Information</h3>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faUserShield} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="characterName"
                            type="text"
                            label="Character Name"
                            fullWidth
                            helperText={<span></span>}
                            onKeyPress={onKeyPress}
                        />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="characterClass"
                            type="text"
                            label="Class"
                            fullWidth
                            helperText={<span></span>}
                            onKeyPress={onKeyPress}
                        />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="characterLevel"
                            type="text"
                            label="Level"
                            fullWidth
                            helperText={<span></span>}
                            normalize={normalizeLevel}
                            onKeyPress={onKeyPress}
                        />
                    </div>
                </div>
            </div>
            <div className="panel-adt">
                <h3>Experience & Playtimes</h3>
                <div className="adt-flex-container">
                    <div className="adt-flex-item">
                        <p style={{margin:0}}>Please list <i>all</i> relevant MMO experience as well as any other titles you feel appropriate.</p>
                    </div>
                </div>
                <FieldArray name="gameHistory" component={renderGames} onKeyPress={onKeyPress} />
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faClock} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="playtime"
                            type="text"
                            label="Weekly playtime"
                            fullWidth
                            helperText={"How many hours a week are you planning to dedicate to "+props.chapter.game.title+"?"}
                            normalize={normalizeHours}
                            onKeyPress={onKeyPress}
                        />
                    </div>
                </div>
            </div>
            <div className="panel-adt">
                <h3>Personality & Interest</h3>
                <div className="adt-flex-container">
                    <div className="adt-flex-item">
                        <p style={{margin:0}}>Please select the top three choices that are most important/fun to you.</p>
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faDna} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="playerTypeOne"
                            select
                            label="Choice One"
                            fullWidth
                            helperText={<span></span>}
                        >
                            {toArray(props.interests).sort((a, b) => (a.created - b.created)).map((interest) => (
                                <MenuItem key={interest.id} value={interest.interest}>{interest.interest}</MenuItem>
                            ))}
                        </Field>
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="playerTypeTwo"
                            select
                            label="Choice Two"
                            fullWidth
                            helperText={<span></span>}
                        >
                            {toArray(props.interests).sort((a, b) => (a.created - b.created)).map((interest) => (
                                <MenuItem key={interest.id} value={interest.interest}>{interest.interest}</MenuItem>
                            ))}
                        </Field>
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="playerTypeThree"
                            select
                            label="Choice Three"
                            fullWidth
                            helperText={<span></span>}
                        >
                            {toArray(props.interests).sort((a, b) => (a.created - b.created)).map((interest) => (
                                <MenuItem key={interest.id} value={interest.interest}>{interest.interest}</MenuItem>
                            ))}
                        </Field>
                    </div>
                </div>
                <div className="adt-flex-container">
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faParagraph} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <Field component={TextField}
                            name="whyJoin"
                            type="text"
                            label="Please explain your choices and interest in Addiction."
                            fullWidth
                            multiline
                            helperText="Press Enter for more lines."
                        />
                    </div>
                </div>
            </div>
            <div className="panel-adt clearfix">
                { props.errors ? (
                    <Alert bsStyle="danger">An Error occured.</Alert>
                    ) : ( '' )
                }
                <Button className="pull-right" type="submit" disabled={props.pristine || props.pending}>
                    {(props.pending) ? (
                    <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                    ) : ('')}
                    Submit {props.chapter.game.title} Application
                </Button>
            </div>
        </Form>
    )
};

export default reduxForm({
    form: 'stepOne',
    enableReinitialize: true,
    validate })(StepOneForm)


// WEBPACK FOOTER //
// ./src/Applications/StepOneForm.js